const HexToHSL = hex => {
  if (!hex || typeof hex !== "string") return { h: 0, s: 0, l: 0 };
  hex = hex.replace(/^#/, "");
  if (![3, 6].includes(hex.length)) return null;
  if (hex.length === 3)
    hex = hex
      .split("")
      .map(x => x + x)
      .join("");
  const num = parseInt(hex, 16);
  let r = (num >> 16) & 255,
    g = (num >> 8) & 255,
    b = num & 255;
  r /= 255;
  g /= 255;
  b /= 255;
  const cmax = Math.max(r, g, b),
    cmin = Math.min(r, g, b),
    delta = cmax - cmin;
  let h = 0,
    s = 0,
    l = (cmax + cmin) / 2;
  if (delta) {
    s = delta / (1 - Math.abs(2 * l - 1));
    h =
      ((cmax === r
        ? (g - b) / delta + (g < b ? 6 : 0)
        : cmax === g
          ? (b - r) / delta + 2
          : (r - g) / delta + 4) *
        60) %
      360;
  }
  return { h: Math.round(h), s: +(s * 100).toFixed(1), l: +(l * 100).toFixed(1) };
};

const HSLToHex = ({ h, s, l }) => {
  l /= 100;
  s /= 100;
  const a = s * Math.min(l, 1 - l);
  const f = n => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0");
  };
  return `#${f(0)}${f(8)}${f(4)}`.toUpperCase();
};

const alternateHSL = ({ h, s, l, hOffset = 0, sOffset = 0, lOffset = 0 }) => {
  // If lightness is above 50, make it darker; if below or equal, make it lighter
  let newL =
    l > 50 ? Math.max(l - Math.abs(lOffset || 10), 0) : Math.min(l + Math.abs(lOffset || 10), 100);
  let newH = (h + hOffset) % 360;
  let newS = Math.min(Math.max(s + sOffset, 0), 100);
  return { h: newH, s: newS, l: newL };
};

const isColorDark = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return !!(
    parseInt(result[1], 16) * 0.299 +
      parseInt(result[2], 16) * 0.587 +
      parseInt(result[3], 16) * 0.114 <=
    186
  );
};

const extendHex = hex => {
  if (!hex || typeof hex !== "string") return hex;
  const stripped = hex.replace(/^#/, "");
  if (stripped.length === 3 || stripped.length === 4) {
    const expanded = stripped
      .split("")
      .map(x => x + x)
      .join("");
    return `#${expanded}`;
  }
  return stripped.length === 6 || stripped.length === 8 ? `#${stripped}` : hex;
};

export { HexToHSL, isColorDark, alternateHSL, HSLToHex, extendHex };
